<template>
  <div class="add-success">
    <i class="iconfont icon-enable"></i>
    <p>保存成功</p>
    <div @click="reSend" class="btn publish">立即发布</div>
    <div @click="unPublish" class="btn nopub">暂不发布</div>
    <van-checkbox class="allVisitor" shape="square" v-model="checked">允许游客答题</van-checkbox>
  </div>
</template>

<script>
import {releasebase} from '@/api'
// eslint-disable-next-line no-unused-vars
import {wsMixin} from '@/views/activePlay/wsMixin.js'
export default {
  mixins: [wsMixin],
  data() {
    return {
      id: this.$route.params.id,
      paperId: this.$route.query.paperId,
      checked: false
    }
  },
  methods: {
    unPublish() {
      this.$router.push(`/activeQueList/${this.id}`)
    },
    async reSend() {
      if (!this.ws) {
        return this.$Toast.success('发布失败,请重试')
      }
      const params = {
        eventId: this.id,
        paperId: this.paperId,
        type: 2, // type 1. 标准出题  2. 快速出题
        allowVisitors: this.checked ? 1 : 2
      }
      const result = await releasebase(params)
      if (result.code === 0) {
        if (this.ws) {
          const obj = {
            c: 30001,
            a: {
              isCheckbox: '', // isCheckbox: 1. 单选 2. 多选
              objectId: this.paperId, // 答题卡id
              objectType: 1 // type 1. 标准出题  2. 快速出题
            },
            e: this.id
          }
          this.ws.send(JSON.stringify(obj))
          this.$Toast.success('发布成功')
          setTimeout(() => {
            this.unPublish()
          }, 2000)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.add-success {
  padding-top: 40px;
  min-height: 100vh;
  text-align: center;
}
i.icon-enable {
  font-size: 60px;
  color: #04c160;
}
p {
  color: #303133;
  font-weight: 700;
  margin-bottom: 60px;
}
div.btn {
  margin: 0 auto;
  text-align: center;
  line-height: 48px;
  width: 60%;
  border-radius: 50px;
}
div.publish {
  margin-bottom: 20px;
  color: #fff;
  background: linear-gradient(270deg, #4465f3, #4a86f6);
}
div.nopub {
  margin-bottom: 20px;
  border: 2px solid #4670f4;
  color: #4465f3;
}
.allVisitor {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
